import { DisputeConfigs, DisputeStatus } from "@portal/types/entities/dispute";

const disputeConfigs: DisputeConfigs = {
  OPEN: {
    label: "Open",
    style: {
      borderColor: "var(--red-1)",
      backgroundColor: "var(--red-1)",
      textColor: "var(--red-6)",
    },
  },
  WAITING_ON_CUSTOMER: {
    label: "Waiting on Customer",
    style: {
      borderColor: "var(--gold-1)",
      backgroundColor: "var(--gold-1)",
      textColor: "var(--gold-6)",
    },
  },
  CLOSED: {
    label: "Closed",
    style: {
      borderColor: "var(--green-1)",
      backgroundColor: "var(--green-1)",
      textColor: "var(--green-6)",
    },
  },
};

export function getDisputeStatusDetails(status: DisputeStatus) {
  return disputeConfigs[status];
}

// export const sortUserInfoPredicate = (
//   userA: Unpacked<DisputeList["owners"]>,
//   userB: Unpacked<DisputeList["owners"]>
// ) => {
//   const nameA = userA.first_name.toUpperCase();
//   const nameB = userB.first_name.toUpperCase();
//   if (nameA < nameB) return -1;
//   if (nameA > nameB) return 1;
//   return 0;
// };
